var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.07031 0.625C7.07031 5.57312 4.39625 10 0.625 10C4.39625 10 7.07031 14.4272 7.07031 19.375C7.07031 14.4272 9.74438 10 13.5156 10C9.74438 10 7.07031 5.57312 7.07031 0.625ZM14.6875 10C14.6875 12.4744 13.3509 14.6875 11.4647 14.6875C13.3509 14.6875 14.6875 16.9013 14.6875 19.375C14.6875 16.9013 16.0241 14.6875 17.9103 14.6875C16.0241 14.6875 14.6875 12.4744 14.6875 10ZM16.1525 0.625C16.1525 3.09906 14.8159 5.3125 12.9297 5.3125C14.8156 5.3125 16.1525 7.52625 16.1525 10C16.1525 7.52625 17.4891 5.3125 19.3753 5.3125C17.4891 5.3125 16.1525 3.09906 16.1525 0.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.04442084f47a41fa6657c9e8481af761.svg";
export { ForwardRef as ReactComponent };